import { render, staticRenderFns } from "./deployment_status_link.vue?vue&type=template&id=c0505d98"
import script from "./deployment_status_link.vue?vue&type=script&lang=js"
export * from "./deployment_status_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports